import React, { useState } from "react";
import { useAuth } from "../../context/AuthContext";
import { FaSpinner, FaUser } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import background from "../../image/fondo_nubes.jpg";

const ForgotPassword = () => {
  const [correo, setCorreo] = useState("");
  const [loading, setLoading] = useState(false);
  const { requestOtp, message } = useAuth(); // Verifica que provenga de useAuth
  const navigate = useNavigate(); // Para redirigir al login

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await requestOtp(correo); // Pasa navigate aquí
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="relative flex justify-center items-center min-h-screen bg-gray-100 p-4">
      {/* Imagen de fondo con opacidad */}
      <div
        className="absolute inset-0 bg-cover bg-center opacity-70 bg-black/50"
        style={{ backgroundImage: `url(${background})` }}
      ></div>
      {/* Overlay oscuro con opacidad */}
      <div className="absolute inset-0 bg-black/50"></div>
      <div className="relative w-full max-w-md bg-main-bg-sidebar p-8 rounded-2xl shadow-2xl">
        <h2 className="text-3xl mb-6 text-white font-bold text-center">
          Recuperar Contraseña
        </h2>
        <form onSubmit={handleSubmit}>
          <div className="relative mb-6">
            <input
              type="email"
              name="correo"
              placeholder="Correo Electrónico"
              value={correo}
              onChange={(e) => setCorreo(e.target.value)}
              required
              className="w-full bg-transparent border border-white/40 rounded-full px-4 py-3 text-white placeholder-gray outline-none focus:border-blue-300"
            />
            <FaUser className="absolute top-1/2 right-4 transform -translate-y-1/2 text-white" />
          </div>
          <div className="flex justify-center">
            <button
              type="submit"
              className="w-[20rem] bg-white text-black font-semibold p-3 rounded-full hover:bg-gray-200 transition flex justify-center items-center"
              disabled={loading}
            >
              {loading ? (
                <FaSpinner className="animate-spin mr-2" />
              ) : (
                "Enviar OTP"
              )}
            </button>
          </div>

          {message && (
            <p className="mt-4 text-red-500 text-center">{message}</p>
          )}
        </form>
        {/* Botón para ir a login */}
        <div className="mt-6 text-center">
          <button
            onClick={() => navigate("/login")}
            className="text-white underline hover:text-blue-300 transition"
          >
            Volver a Iniciar Sesión
          </button>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
